import { Routes, Route } from "react-router-dom";
import NoMatch from "./no_match";
import MainPage from "../page/main_page/main_page";
import IntroPage from "../page/intro_page/intro_page";
import CommunityPage from "../page/community_page/community_page";
import ChargePage from "../page/charge_page/charge_page";
import ProcedurePage from "../page/procedure_page/procedure_page";
import ServicePage from "../page/service_page/service_page";
import LoginPage from "../page/login_page/login_page";

function RoutesSetup() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/intro/:contents" element={<IntroPage />} />
      <Route path="/procedure" element={<ProcedurePage />} />
      <Route path="/charge/:contents" element={<ChargePage />} />
      <Route path="/service/:contents" element={<ServicePage />} />
      <Route path="/community/:contents" element={<CommunityPage />} />
      <Route path="/community/:contents/:actions" element={<CommunityPage />} />
      <Route
        path="/community/:contents/:actions/:postId"
        element={<CommunityPage />}
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
}

export default RoutesSetup;
